import reactComponentLoader from 'scripts/react-component-loader'

import App from './App'
import { parsedItemsNewMyAccount } from './utils'

export type AppProps = {
  itemsMyAccount: string
  isCaptchaEnabled: boolean
  isCaptchaEnterpriseEnabled: boolean
  captchaKey: string
  isFavoriteStoreFieldReadonly?: boolean
  mdmClientNumber: number
}

const AppWithProps = ({
  itemsMyAccount,
  isCaptchaEnabled,
  isCaptchaEnterpriseEnabled,
  captchaKey,
  isFavoriteStoreFieldReadonly,
  mdmClientNumber
}: AppProps) => {
  const itemsMenu = parsedItemsNewMyAccount(itemsMyAccount)

  return (
    <App
      itemsMyAccount={itemsMenu}
      isCaptchaEnabled={isCaptchaEnabled}
      isCaptchaEnterpriseEnabled={isCaptchaEnterpriseEnabled}
      captchaKey={captchaKey}
      isFavoriteStoreFieldReadonly={isFavoriteStoreFieldReadonly}
      mdmClientNumber={mdmClientNumber}
    />
  )
}

reactComponentLoader(AppWithProps, '[data-page-my-account]')

export default AppWithProps
